import { render, staticRenderFns } from "./noteDetail.vue?vue&type=template&id=2c82f28a&"
import script from "./noteDetail.vue?vue&type=script&lang=js&"
export * from "./noteDetail.vue?vue&type=script&lang=js&"
import style0 from "./noteDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports